module.exports = __webpack_public_path__ + "img/3.e18e8a8e.png";